/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskWebhoseDetailsEntry } from './ExecRiskWebhoseDetailsEntry';
import {
    ExecRiskWebhoseDetailsEntryFromJSON,
    ExecRiskWebhoseDetailsEntryFromJSONTyped,
    ExecRiskWebhoseDetailsEntryToJSON,
} from './ExecRiskWebhoseDetailsEntry';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedWebhoseArticlesResponse
 */
export interface ExecRiskPaginatedWebhoseArticlesResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedWebhoseArticlesResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskWebhoseDetailsEntry>}
     * @memberof ExecRiskPaginatedWebhoseArticlesResponse
     */
    results: Array<ExecRiskWebhoseDetailsEntry>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedWebhoseArticlesResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedWebhoseArticlesResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedWebhoseArticlesResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedWebhoseArticlesResponse interface.
 */
export function instanceOfExecRiskPaginatedWebhoseArticlesResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedWebhoseArticlesResponseFromJSON(json: any): ExecRiskPaginatedWebhoseArticlesResponse {
    return ExecRiskPaginatedWebhoseArticlesResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedWebhoseArticlesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedWebhoseArticlesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskWebhoseDetailsEntryFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedWebhoseArticlesResponseToJSON(value?: ExecRiskPaginatedWebhoseArticlesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskWebhoseDetailsEntryToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

